<template>
    <div>
      <p v-if="timeRemaining <= 0">Timer expired!</p>
      <div  :class="`val time ${timer_color_c}`" v-else>
        <!-- <p>{{ days }} days {{ hours }} hours {{ minutes }} minutes {{ seconds }} seconds {{ milliseconds }} milliseconds</p> -->
        <!-- <p>{{ days }} days {{ hours }} hours {{ minutes }} minutes {{ seconds }} seconds </p> -->
        <feather-icon
            icon="ClockIcon"
            size="15"
            />
          <span class="day" v-if="days > 0">{{ days }}</span>
          <font v-if="days > 0">{{$t('gen.card2')}}  </font>
          <span class="hour" v-if="hours > 0">{{(hours < 10) ? "0" : "" }}{{hours }}</span>
          <font v-if="hours > 0">:</font>
          <span class="min">{{(minutes < 10) ? "0" : "" }}{{minutes }}</span>
          <font>:</font>
          <span class="sec">{{(seconds < 10) ? "0" : "" }}{{ seconds }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props:{
      timeInMillis: {
        type: Number,
        required:true
      }
    },
    data() {
      return {
			  timer_color_c: 'move-color',
        timeRemaining: this.timeInMillis,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        worker: null
      };
    },
    watch: {
      timeInMillis(val){
        // console.log("val", val);
        this.resetTimer(val)
      }
    },
    mounted() {
      
      this.worker = new Worker(window.location.origin+'/countdownWorker.js');
      // this.worker = new Worker('http://localhost:8080/countdownWorker.js');
      this.worker.onmessage = (event) => {
        this.timeRemaining = event.data;
        this.calculateTime();
      };
      this.worker.postMessage(this.timeRemaining);
    },
    methods: {
      calculateTime() {
        let time = this.timeRemaining;
  
        this.days = Math.floor(time / (1000 * 60 * 60 * 24));
        time %= (1000 * 60 * 60 * 24);
  
        this.hours = Math.floor(time / (1000 * 60 * 60));
        time %= (1000 * 60 * 60);
  
        this.minutes = Math.floor(time / (1000 * 60));
        time %= (1000 * 60);
  
        this.seconds = Math.floor(time / 1000);
        time %= 1000;
  
        this.milliseconds = time;
        if (this.days == 0 ){
          this.timer_color_c = 'red-color';
        }
        // console.log('seconds', this.timeRemaining);
        this.$emit("timer-progress", this.timeRemaining);
        if(this.timeRemaining < 1000){
          this.$emit("timer-end");
        }
        if(this.days == 0 && this.hours == 0 && this.minutes < 3 ){
          this.$emit("timer-end-soon");
        }
      },
    resetTimer(val) {
      // Stop the current countdown timer
      this.worker.terminate();
      
      this.timeRemaining = val;

      // Start a new countdown timer with the initial time value
      this.worker = new Worker(window.location.origin+'/countdownWorker.js');
      // this.worker = new Worker('http://localhost:8080/countdownWorker.js');
      this.worker.onmessage = (event) => {
        this.timeRemaining = event.data;
        this.calculateTime();
      };
      this.worker.postMessage(this.timeRemaining);
    }
  },
  beforeDestroy() {
    // Terminate the Web Worker when the component is destroyed
    if (this.worker) {
      this.worker.terminate();
    }
    }
  };
  </script>